module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popHeader"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "mintui mintui-back",
    on: {
      "click": _vm.cancel
    }
  }), _vm._v("\n\n     " + _vm._s(_vm.title) + "\n        "), _c('div', {
    staticClass: "sureGear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-aa229062","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/popHeader.vue
// module id = 1829
// module chunks = 107